
import { defineComponent } from 'vue';
import GreenHeader from '@/components/GreenHeader.vue';
import GreenBody from '@/components/GreenBody.vue';
import LinksFooter from '@/components/LinksFooter.vue';
import ContactsInfo from '@/components/ContactsInfo.vue';
import HorizontalLine from '@/components/HorizontalLine.vue';

export default defineComponent({
  name: 'HomeView',
  components: {
    GreenHeader,
    GreenBody,
    ContactsInfo,
    LinksFooter,
    HorizontalLine,
  },
});
